const NEEDED_RIGHTS = ['POLICIES_PREMIUM_SHOW'];
const ACTIONS_RIGHTS = { updatePaymentType: 'PREMIUM_TYPE_PAIEMENT_UPDATE' };

export { NEEDED_RIGHTS, ACTIONS_RIGHTS };
